import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-insert-emoticon",
  templateUrl: "./med-icon-insert-emoticon.component.html",
})
export class MedIconInsertEmoticonComponent extends SvgMixinComponent {}
